import { render, staticRenderFns } from "./ImgRankinP1.vue?vue&type=template&id=01263ca0"
import script from "./ImgRankinP1.vue?vue&type=script&lang=js"
export * from "./ImgRankinP1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports